export enum CashierOfficeSectorEnum {
  PUBLIC = 1,
  PENSIONERS = 2,
  EDUCATIONAL = 3,
}
